export const captchaKeys = {
	USERS_CAPTCHA_KEY: '6LcA5-QlAAAAAKXTrgijym6EKt-b3L_roiwMowkA'
}
